import { render, staticRenderFns } from "./FocusPage.vue?vue&type=template&id=5fbf0205&"
import script from "./FocusPage.vue?vue&type=script&lang=js&"
export * from "./FocusPage.vue?vue&type=script&lang=js&"
import style0 from "./FocusPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports